<!--
 * @description: 登录页
 * @param: 
 * @return: 
-->
<template>
  <div class="login-main-container">
    <div class="login-panel">
      <div class="login-panel-left"></div>

      <div class="login-panel-right">
        <div class="login-panel-logo"></div>
        <div class="login-panel-body">
          <div class="login-panel-body-title-cn login-panel-body-title-en">
            休恩设备服务平台
          </div>
          <!-- <div class="login-panel-body-title-cn login-panel-body-title-en">
            Hardware Management Platform
          </div> -->
          <div class="login-panel-body-field-label">用户名</div>
          <el-input
            type="text"
            placeholder="请输入账号"
            class="login-panel-body-field"
            v-model="userName"
            @keyup.enter="userNameKeyUp"
            ref="userNameDom"
          ></el-input>
          <div
            class="login-panel-body-field-label login-panel-body-field-label-password"
          >
            登陆密码
          </div>
          <el-input
            type="password"
            placeholder="请输入密码"
            class="login-panel-body-field"
            v-model="password"
            ref="passwordDom"
            @keyup.enter="passwordKeyUp"
          ></el-input>
          <!-- <div style="display:'flex'">
            <el-input  placeholder="请输入验证码"></el-input>
            <span>sssss</span>
          </div> -->
          <div class="login-code">
            <!-- @change="($event,value)=>{login(value,$event)}" -->
            <el-input
              v-model="identify"
              placeholder="请输入验证码"
              @keyup.enter="passwordKeyUp"
            ></el-input>
            <div class="login-code-img-container">
              <login-img :identifyCode="loginCode" @click="refreshCode" />
              <span class="login-code-img-text">点击图片刷新</span>
            </div>
          </div>

          <div class="login-panel-body-button" @click="login">登录</div>
          <!-- <div class="login-panel-body-button">登录</div> -->
        </div>
      </div>
    </div>
    <div class="footer-name">
      <span>京ICP备2022031684号-3</span>
      <span>北京休恩博得科技股份有限公司</span>
    </div>
  </div>
</template>

<script>
import { loginApi, getTabs } from "@/api/index.js";

import { errMsg } from "@/notify/index.js";
import loginImg from "@/pages/dialog/loginImg";
import AES from "@/util/Cryptography.js";
import { useStore } from "vuex";
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  getCurrentInstance,
} from "vue";

export default defineComponent({
  name: "login",
  components: {
    loginImg,
  },
  setup() {
    let data = reactive({
      identify: "",
      loginCode: "9527",
      userName: "",
      password: "",
      navi: null,
      userNameDom: null,
      passwordDom: null,
      bg: "login_bg_img",
    });

    let store = useStore();

    onMounted(() => {
      // debugger
      // let ws01 = proxy.$websocket;
      //  = new WebSocket("ws://192.168.1.160:8001/ws?qz="+sessionToKen);
      let storage = window.localStorage.getItem("login");

      if (storage) {
        let loginObj = JSON.parse(storage);
        if (loginObj) {
          window.localStorage.removeItem("login");
          methods.loginFn(loginObj.userName, loginObj.password);
        }
      }

      data.userNameDom.focus();
      data.loginCode = [1, 2, 3, 4].map((i) => methods.randomNum(0, 9));
      methods.refreshCode();
    });

    let methods = {
      randomNum(min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      },
      refreshCode() {
        //   console.log('获取验证码执行')
        const num = [1, 2, 3, 4].map((item) => methods.randomNum(0, 9));
        data.loginCode = num.join("");
        console.log(data.loginCode);
      },
      /* 获取焦点 */
      userNameKeyUp() {
        data.passwordDom.focus();
      },
      passwordKeyUp() {
        methods.login();
      },
      /* 登录 */
      login(value, $event) {
        // console.log("执行登录",$event)
        if (!data.userName) {
          errMsg("用户名不能为空");
          return;
        }

        if (!data.password) {
          errMsg("密码不能为空");
          return;
        }
        if (!data.identify) {
          errMsg("请输入验证码");
          return;
        }

        this.loginFn(data.userName, data.password);
      },
      /**
       * @description: 登录API
       * @param {*} userName  账号
       * @param {*} password 密码
       * @return {*}
       */

      loginFn(userName, password) {
        if (data.identify != data.loginCode) {
          errMsg("验证码不正确");
          return;
        }
        loginApi({
          LoginName: userName,
          Password: AES.getAES(password),
          // pwd: encrypt(password)
        })
          .then((data) => {
            if (data.code == 0) {
              let sessionId = data.data.token;
              let wsUserId = data.data.UserId;
              localStorage.setItem(
                "del_yes_or_no",
                JSON.stringify(data.data.IsAdmin)
              );
              // 强制重置 WebSocket 连接
              // const { proxy } = getCurrentInstance();
              // proxy.$resetWebsocket(); // 假设你在 main.js 中定义了此方法
              // const ws = proxy.$websocket();

              localStorage.setItem(
                "user_name",
                JSON.stringify(data.data.UserName)
              );
              localStorage.setItem("openId", data.data.OpenId);
              localStorage.setItem("RoleId", data.data.RoleId);
              // localStorage.setItem("UserId", data.data.UserId || "")
              // app.config.globalProperties.$websocket = new WebSocket("ws://192.168.1.160:8001/ws?qz=dddkk");
              const obj = {
                userName,
                password,
                sessionId,
                wsUserId,
              };
              localStorage.setItem("loginSession", JSON.stringify(obj));
              store.dispatch("set_loginStatus", obj);
              // store.dispatch("set_naviData")
              getTabs()
                .then((data) => {
                  if (data.code == 0) {
                    if (data.data) {
                      // 去掉记忆页面 并且首先显示首页
                      let flag = data.data.tabs.find(
                        (item) => item.text == "首页"
                      );
                      if (!flag) {
                        flag = {
                          text: "首页",
                          id: "firstPage",
                          closable: false,
                          path: "/home/firstPage",
                          icon: "el-icon-s-home",
                        };
                      }
                      let tabs = [flag];
                      let selectedTab = data.data.selectedTab;
                      let currentChildPath = data.data.currentChildPath;
                      // console.log(tabs, "tabs,,,,");
                      store.dispatch("set_tabs", tabs);
                      sessionStorage.setItem("set_tabs", JSON.stringify(tabs));
                      // console.log(selectedTab, "selectedTab,;;;");

                      // store.dispatch("set_selectedTab", selectedTab);
                      currentChildPath = "/home/firstPage";
                      store.dispatch(
                        "set_currentChildRouterPath",
                        currentChildPath
                      );

                      store.dispatch("set_naviData");
                    } else {
                      store.dispatch("set_tabs");

                      store.dispatch("set_selectedTab");

                      store.dispatch(
                        "set_currentChildRouterPath",
                        "/home/firstPage"
                      );
                    }
                  } else {
                    errMsg(data.message);
                  }
                })
                .catch((err) => {
                  errMsg(err);
                });
            } else {
              errMsg(data.message);
            }
          })
          .catch(() => {
            errMsg("服务异常");
          });
      },
    };

    return {
      ...toRefs(data),
      ...methods,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.login-main-container {
  display: flex;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  @include background_image("login_bg_img");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .login-panel {
    // width: 640px;
    height: 506px;
    // margin-top: 280px;
    // margin-left: 240px;
    margin: 0 auto;
    position: relative;
    top: 200px;
    @include background_color("login_panel_bgColor");
    border-radius: 25px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 16px rgba(0, 0, 0, 0.04);

    box-sizing: border-box;
    display: flex;
    // flex-direction: column;
    overflow: hidden;

    .login-panel-left {
      width: 680px;
      background: url(~@/assets/images/light/login_pic.png) no-repeat;
      background-size: 100% 100%;
    }
    .login-panel-right {
      width: 560px;
      padding-top: 32px;
      padding-bottom: 50px;
      padding-left: 40px;
      padding-right: 40px;
    }

    .login-panel-logo {
      @include background_image("login-panel-logo");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 123px;
      height: 72px;
      margin: 0 auto;
      // width: (353px /2);
      // height: (208px /2);
    }

    .login-panel-body {
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-content: center;

      .login-panel-body-title-cn {
        font-family: 黑体;
        // 红色10 绿色29 蓝色73
        color: rgb(10, 29, 73);
        // @include font_family("font_family");
        // @include font_color("login_panel_title");
        font-size: 30px;
        line-height: 30px;
        width: fit-content;
        height: 30px;
      }

      .login-panel-body-title-en {
        // font-size: 14px;
        // height: 14px;
        // line-height: 14px;
        margin-top: 15px;
        margin-bottom: 40px;
      }

      .login-panel-body-field-label {
        display: flex;
        width: 380px;
        @include font_family("font_family");
        @include font_color("login_panel_input_label_color");
        height: 18px;
        font-size: 18px;
        line-height: 18px;
        margin-bottom: 10px;
      }

      .login-panel-body-field-label-password {
        margin-top: 20px;
      }

      .login-panel-body-field {
        width: 380px;
      }

      .login-panel-body-button {
        @include background_color("login_panel_button_bg");
        @include font_family("font_family");
        width: 180px;
        height: 50px;
        margin-top: 50px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        @include font_color("login_panel_button_fontColor");
        font-size: 24px;
        cursor: pointer;

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
.login-code {
  display: flex;
  margin-top: 10px;
  padding-left: 40px;
  height: 22px;
  width: 100%;
  justify-content: space-between;
  :deep(.el-input__inner) {
    border-radius: 5px;
    transform: translate(8px, 5px);
    height: 46px;
    width: 60%;
  }
  .login-code-img-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .login-code-img-text {
      position: absolute;
      top: 260%;
      color: rgb(231, 88, 32);
    }
  }
}
.footer-name {
  position: fixed;
  bottom: 0px;
  width: 100%;
  color: #fff;
  text-align: center;
  padding-bottom: 8px;

  span {
    padding: 10px 30px;
  }
}
</style>
